import React, { Component } from 'react';

import { getRandom } from '../../../utils/numbers.js'

import './Stars.css'

import Star from './Star'

class Stars extends Component {

    shouldComponentUpdate(nextProps, nextState) {

        return this.props.viewport !== nextProps.viewport || this.props.isActive !== nextProps.isActive ? true : false
            
    }


    render() {

        const { viewport, isActive } = this.props

        const total = 10


        let stars = []

        for (var i = 0; i < total; i++) {
            
            const top = getRandom(0, viewport.height)
            const delay = getRandom(0, 1000) / 100
            const speed = getRandom(5, 10)
            const width = getRandom(5, 5)
            const r = getRandom(0, 255)
            const g = getRandom(0, 255)
            const b = getRandom(0, 255)
            // const left = getRandom(0, viewport.width)
            const left = -width
            
            stars.push(<Star r={r} g={g} b={b} key={i} viewport={viewport} top={top} left={left} delay={delay} speed={speed} width={width} isActive={isActive} />)

        }

        return (
            <div className="stars">
                {stars}
            </div>
        );
    }
}

export default Stars;